module.exports = __webpack_public_path__ + "static/media/6.dded4778.jpg";